import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLabs } from '../../../api/labs';
import useLabsStore from '../../../store/labsStore';
import useStore from '../../../store/store';

export const RecommendedLabs = () => {
  const { labs, setLabs } = useLabsStore();
  const { setLoading, loading } = useStore();
  const navigate = useNavigate();

  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    const serverBase = process.env.REACT_APP_SERVER?.replace('/api', '');
    return `${serverBase}/${url}`;
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getLabs();
      setLabs(res);
    } catch (error) {
      console.log('error in loading labs', error);
    } finally {
      setLoading(false);
    }
  }, [setLabs, setLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <VStack p={[5, 10]} spacing={[10]} width="100%" id="labs">
      <Heading
        bgGradient="linear(to-r, teal.600, blue.500)"
        bgClip="text"
        fontSize={[32, 42]}
        fontWeight="bold"
        textAlign="center"
      >
        Recommended Labs
      </Heading>

      {loading ? (
        <Spinner size="xl" color="teal" />
      ) : (
        <Flex
          wrap="wrap"
          justify="center"
          gap={8}
          width="100%"
          px={[2, 4, 10, 20]}
        >
          {labs?.slice(0, 4).map((lab) => (
            <Box
              key={lab._id}
              p={5}
              borderRadius="20px"
              boxShadow="0 4px 20px rgba(0,0,0,0.08)"
              width={['100%', '300px']}
              bg="white"
              transition="transform 0.3s"
              _hover={{ transform: 'translateY(-5px)' }}
              cursor="pointer"
              onClick={() => navigate(`/lab?labId=${lab._id}`)}
            >
              <VStack spacing={4}>
                <Box height="120px" width="100%" display="flex" alignItems="center" justifyContent="center">
                  <Image
                    src={getImageUrl(lab.labLogoUrl) || getImageUrl(lab.images?.frontPics?.[0]) || '/logo192.png'}
                    fallbackSrc='/logo192.png'
                    alt={lab.labName}
                    maxH="100%"
                    objectFit="contain"
                  />
                </Box>
                <VStack spacing={1}>
                  <Text fontWeight="bold" fontSize="lg" color="gray.700" textAlign="center">
                    {lab.labName}
                  </Text>
                  <Text color="gray.500" fontSize="sm">
                    {lab.city}
                  </Text>
                  <Text color="teal.600" fontSize="xs" fontWeight="600">
                    {lab.tagLine || "Certified Diagnostic Center"}
                  </Text>
                </VStack>
              </VStack>
            </Box>
          ))}
        </Flex>
      )}

      <Button
        variant="ghost"
        color="teal"
        onClick={() => navigate('/labs')}
      >
        View All Labs
      </Button>
    </VStack>
  );
};
